module.exports = __webpack_public_path__ + "static/media/Vacaciones.525a2cb6.svg";